





























































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
import { routingControlModule } from '../../store/modules/RoutingControl';
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
import router from '../../router';
import { applicationFormModule } from '../store/modules/ApplicationForm';
import { uketsukeManagementModule } from '../store/modules/UketsukeManger';
import { ApplicationProcessType} from '../fixed/ApplicationProcessType';
import { UketsukeScreenName } from '../fixed/UketsukeScreenName';
import { AuthoritiesId } from '@/CommonUtils/fixed/AuthoritiesId';
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class UketsukeOrderMain extends ApiAccessBase {
  private businessTypeName: string = '';
  private createAuthority: boolean = false;

  private created() {
    // 権限の設定
    this.createAuthority = this.checkAuthority(AuthoritiesId.APP_CREATE);

    if (applicationFormModule.CHECK_TYPE_CONST) {
      this.businessTypeName = '建設工事';
      applicationFormModule.setTypeConst();
    } else if (applicationFormModule.CHECK_TYPE_CONSUL) {
      this.businessTypeName = '建設コンサル';
      applicationFormModule.setTypeConsul();
    // 20210910 [01_調達区分_維持管理業務追加] ueda ADD Start
    } else if (applicationFormModule.CHECK_TYPE_MAINTENANCE) {
      this.businessTypeName = '土木施設維持管理';
      applicationFormModule.setTypeMaintenance();
    // 20210910 [01_調達区分_維持管理業務追加] ueda ADD End
    } else if (applicationFormModule.CHECK_TYPE_GOODS) {
      this.businessTypeName = '物品・役務';
      applicationFormModule.setTypeGoods();
    }
    // ストアのリセット
    applicationFormModule.resetFormData();
    applicationFormModule.moduleResetDetail();
  }


  //*持参又は郵送受付分データ入力*/
  private application() {
    routingControlModule.registPrevious(this.$route.name);
    applicationFormModule.setProcessType(ApplicationProcessType.NEW);
    // 遷移元設定
    applicationFormModule.setTransitionSourceScreen(UketsukeScreenName.UKETSUKE_ORDER_MAIN);
    router.push({name: UketsukeScreenName.APPLICATION_FORM});
  }
  //*資格申請データの修正*/
  private  modify() {
    routingControlModule.registPrevious(this.$route.name);
    router.push({name: UketsukeScreenName.SEARCH_APPLICATION_TRADER});
  }
  //*インターネット申請用パスワード通知書の発行*/
  private issue() {
    routingControlModule.registPrevious(this.$route.name);
    router.push({name: UketsukeScreenName.PASSWORD_ISSUER_SEARCH});
  }

  /**
   * 前画面に戻る
   */
  private returnPrevious() {
      // 排他制御等（省略中）
      // 修正登録時は排他解除が正常に終了すれば以下の処理を実行

      // モジュールをリセット
      // applicationFormModule.moduleReset();
      // 前画面に戻る
      router.push(routingControlModule.GET_PREVIOUS);
  }
}
